import { Tooltip, TooltipProps } from 'antd';

export type TooltipAtomProps = TooltipProps;

const TooltipAtom = Tooltip;

export default TooltipAtom;
